import { Eye, Users, ShieldCheck, MapPin } from "lucide-react";

const VALUES = [
  {
    icon: Eye,
    title: "Transparência Total",
    text: "Transparência total em todo o processo — custos, prazos e condições sempre claros antes de qualquer decisão.",
  },
  {
    icon: Users,
    title: "Acompanhamento Dedicado",
    text: "Acompanhamento dedicado e personalizado, do primeiro contacto à entrega da sua viatura.",
  },
  {
    icon: ShieldCheck,
    title: "Segurança Garantida",
    text: "Segurança garantida na sua compra e financiamento, com processos verificados em cada etapa.",
  },
  {
    icon: MapPin,
    title: "Perto de Si",
    text: "Atendimento em stand e em várias zonas de Portugal, com acompanhamento online em todo o país.",
  },
];

export default function WhyUs() {
  return (
    <section id="sobre" data-testid="why-us-section" className="py-20 sm:py-24 bg-[#0B1E36] text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-semibold tracking-[0.35em] uppercase text-slate-400 mb-4">
            Sobre Nós
          </p>
          <h2
            data-testid="why-us-heading"
            className="font-display text-3xl sm:text-4xl tracking-tight leading-tight"
          >
            Porquê a SOLUTION CAR PREMIUM
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-300">
            Somos especialistas na comercialização de automóveis e na importação de viaturas da Europa
            para Portugal, com apoio completo ao financiamento. O nosso compromisso: confiança,
            profissionalismo e transparência em cada negócio.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="why-us-grid">
          {VALUES.map(({ icon: Icon, title, text }, i) => (
            <div
              key={title}
              data-testid={`why-us-card-${i}`}
              className="border border-white/15 p-7 hover:border-white/40 hover:bg-white/5 transition-all"
            >
              <span className="w-11 h-11 flex items-center justify-center bg-white text-[#0072C6] mb-5">
                <Icon className="w-5 h-5" />
              </span>
              <h3 className="font-display text-lg">{title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-300">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
